<template>
  <b-card no-body class="mt-3 mb-3">
    <b-card-header align="left">
      <h1>New Account</h1>
    </b-card-header>
    <b-card-body>

      <b-form>

        <rx-text-entry-box
          v-model="first_name"
          id="firstNameInput"
          title-text="First Name"
          placeholder="Enter Your First Name"
          :validation="$v.first_name"
        ></rx-text-entry-box>

        <rx-text-entry-box
          v-model="last_name"
          id="lastNameInput"
          title-text="Last Name"
          placeholder="Enter Your Last Name"
          :validation="$v.last_name"
        ></rx-text-entry-box>

        <rx-text-entry-box
          v-model="title"
          id="titleInput"
          title-text="Your Title"
          placeholder="Enter your title"
        ></rx-text-entry-box>

        <rx-text-entry-box
          v-model="organizationName"
          id="organizationNameInput"
          title-text="Organization Name"
          placeholder="Enter Your Organization's Name"
        ></rx-text-entry-box>

        <rx-text-entry-box
          v-model="email"
          id="emailInput"
          title-text="Email"
          input-type="email"
          placeholder="Enter Your Email"
          :is-disabled="isLoggedIn"
          description=""
          :validation="$v.email"
        ></rx-text-entry-box>

        <rx-dropdown
          v-model="state"
          id="stateInput"
          :options="stateOptions"
          description="Enter the name of the state in which you work"
          title-text="State"
          v-bind:dropdown-col-size="4"
          :validation="$v.state"
        ></rx-dropdown>

        <rx-text-entry-box
          v-model="country"
          id="countryInput"
          description="Enter the name of the country in which you work"
          title-text="Country"
          :validation="$v.country"
        ></rx-text-entry-box>

        <hr style="margin-bottom: 2rem">

        <rx-text-entry-box
          v-model="password1"
          inputType="password"
          id="password1"
          description="Enter a password"
          title-text="Password"
          :validation="$v.password1"
        />

        <rx-text-entry-box
          v-model="password2"
          inputType="password"
          id="password2"
          description="Enter your password again"
          title-text="Confirm Password"
          :validation="$v.password2"
        />

        <!--<b-alert variant="warning">{{submitError}}</b-alert>-->
        <!--{{submitError}}-->
      </b-form>
      <b-alert :show="submitError!==null" variant="danger">Error occurred while creating account. This email address may
        already be in use.
      </b-alert>
      <b-button block @click="saveUserChanges" type="button">Save Changes</b-button>
    </b-card-body>
  </b-card>
</template>

<script>
  import {validationMixin} from 'vuelidate';
  import {helpers} from 'vuelidate/lib/validators';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import {required, sameAs, between, minLength} from 'vuelidate/lib/validators'

  import RxTextEntryBox from './project/inputComponents/RxTextEntryBox'
  import RxDropdown from './project/inputComponents/RxDropdown'
  import {states} from "../../js/stateAbbreviations";

  const stateValidator = helpers.withParams(
    {type: 'required'},
    (state) => {
      if (state !== null) {
        return state.value !== null
      } else {
        return false
      }
    }
  );

  export default {
    name: "AccountPage",
    components: {
      RxTextEntryBox,
      RxDropdown
    },
    mixins: [
      validationMixin
    ],
    data: function () {
      return {
        stateOptions: states,
        first_name: '',
        last_name: '',
        email: '',
        country: '',
        state: {text: null, value: null},
        title: '',
        organizationName: '',
        password1: "",
        password2: "",
        passwordValidationState: null,
        submitError: null,
      }
    },
    computed: {
      // ...mapFields('account',[
      //   "user",
      //   "user.first_name",
      //   "user.last_name",
      //   "user.email",
      //   "user.country",
      //   "user.state",
      //   "user.title",
      //   "user.organizationName",
      // ]),
      ...mapGetters('account', ['isLoggedIn'])
    },
    methods: {
      ...mapActions('account', ['createUser']),
      ...mapMutations('rx', ['setPageValidationState']),
      saveUserChanges() {
        this.$v.$touch();
        if (!this.$v.$anyError) {
          this.createUser({
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            country: this.country,
            state: this.state,
            title: this.title,
            is_admin: false,
            organizationName: this.organizationName,
            password1: this.password1,
            password2: this.password2
          }).then((result) => {
            console.log(result);
            if (result.status === 'Failed') {
              this.submitError = result.payload;
            } else {
              this.submitError = null;
              this.$router.push('/')
            }
          })
        }

        // const result = store.dispatch('account/updateUser');
        // console.log('Update user result:', result);
      },
      setPasswordValidationState() {
        if (this.password1 == this.password2) {
          return true
        } else {
          return false
        }
      }
    },
    validations: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      title: {},
      organizationName: {},
      email: {
        required
      },
      state: {
        required,
        requiredDropdown: stateValidator
      },
      country: {
        required
      },
      password1: {
        required
      },
      password2: {
        required,
        sameAs: sameAs('password1')
      }
    },
    beforeMount() {
      this.setPageValidationState(this.$v)
    },
    mounted() {
      this.$v.$reset();
    }
  }
</script>

<style scoped>

</style>
